import React, { ReactNode } from 'react';
import get from 'lodash/get';

import { MenuItem, Select } from '@mui/material';

import { useSelector, useDispatch } from '../store/utils';
import { variablesChange } from '../store/actions';
import { VariableId } from '../store/types';

import { ControlBox, ControlBoxProps } from '../atoms/control-box';

type Props = {
  selectVariableId: VariableId;
  options: { value: any; label: ReactNode }[];
} & ControlBoxProps;

export const SelectBox = ({ selectVariableId, options, ...props }: Props) => {
  const selectValue = useSelector((s) =>
    selectVariableId ? get(s.variables, selectVariableId) : undefined
  );
  const dispatch = useDispatch();

  return (
    <ControlBox
      control={
        <Select
          value={selectValue}
          onChange={(e) => {
            dispatch(variablesChange({ [selectVariableId]: e.target.value }));
          }}
          sx={{ ml: 'auto' }}
        >
          {options.map(({ label, value }) => (
            <MenuItem value={value} key={value}>
              {label}
            </MenuItem>
          ))}
        </Select>
      }
      {...props}
    />
  );
};
